export var DialogTheme = function (theme) { return ({
    defaultProps: {},
    styleOverrides: {
        root: function (_a) {
            var ownerState = _a.ownerState;
            return ({});
        },
    },
}); };
export default DialogTheme;
//# sourceMappingURL=theme.js.map